<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read instrument instance'">
      <template #gated-content>
        <instrument-instance-card :instrument_instance="instrument_instance" />

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/instrument-instances/${instrument_instance_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="instrument_instance"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="instrument_instance"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import InstrumentInstanceCard from '@/components/lab/instrumentinstance/InstrumentInstanceCard'
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import InstrumentInstanceModel from '@/models/lab/InstrumentInstanceModel'

export default {
  name: "InstrumentInstanceAuditTrail",
  components: {
    PermissionAlertGate,
    InstrumentInstanceCard,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      instrument_instance: null,
      instrument_instance_id: this.$route.params.instrument_instance_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/instrument-instances/${this.instrument_instance_id}`,
            title: "View instrument instance",
            variant: "info",
          }
        ]
      }
    },
  },
  async created () {
    this.loading = true

    this.instrument_instance = new InstrumentInstanceModel({ id: this.instrument_instance_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.instrument_instance.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
